// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.corner-dock {
  position: fixed;
  left: 0;
  /* Bottom offset still mirrors the sticky carousel so the dock sits in the
     same bottom strip on every scroll state. Height is content-sized via
     min-height (NOT locked to --carousel-height anymore — 2026-05-19) so
     the dock's interior layout always fits its rows without space-between
     distributing visible gaps and without the bottom row overflowing on
     routes where the carousel is shorter than the rows need (e.g., /map
     measured 120px which clipped the tabs row).

     min-height per density matches the natural sum of rows + padding + gap:
     standard = 30 (actions) + 48 (bars) + 32 (tabs) + 14 (padding) + 10 (gap) = 134
     compact  = 26 + 42 + 26 + 6 + 4 = 104 (overridden below)

     If a future design pairs the dock to the carousel band again, restore
     \`height: var(--carousel-height, 140px)\`. */
  bottom: var(--carousel-bottom-offset, 0px);
  width: var(--sidebar-width, 280px);
  /* min-height matches --carousel-tray-height so dock and carousel sit
     flush along their top edge. The token (140 standard / 110 compact)
     leaves ~6-10px breathing over the natural content floor so
     space-between distributes visible gaps between rows instead of
     packing them flush. See wiki/decisions/2026-05-19-dock-carousel-sidebar-proportion.md */
  height: auto;
  min-height: 140px;
  /* Paint the dock with the same shell bg so any rounding gap between
     dock min-height (140px) and shell content height (~135px) doesn't
     expose the sidebar TOC text behind the fixed dock. The shell's
     \`height: 100%\` cannot resolve against the auto-height dock and
     collapses to content height, leaving a transparent strip at the
     dock's bottom edge — Edward 2026-05-27. */
  background: rgba(10, 10, 10, 0.94);
  z-index: 45;
  pointer-events: none;
}

:root[data-ui-density="compact"] .corner-dock {
  min-height: 110px;
}

@media (max-width: 768px) {
  .corner-dock { display: none; } /* follows sidebar hide-on-mobile */
}

/* The dock is the bottom of the left column (width-locked to --sidebar-width).
   When the sidebar is collapsed it would shrink to a 0-width box with its shell
   content spilling over the main area, so hide it outright. display:none is safe
   because a collapsed sidebar has no open dock popovers to clip. */
:root[data-sidebar-collapsed="true"] .corner-dock {
  display: none;
}

.corner-dock-shell {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 5px;
  padding: 7px 10px;
  background: rgba(10, 10, 10, 0.94);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  border-right: 1px solid rgba(255, 255, 255, 0.08);
  pointer-events: auto;
  box-shadow: 0 -14px 32px rgba(0, 0, 0, 0.42);
}

/* Compact density: the carousel shrinks to ~116px but the dock's 3-row
   content (actions 30 + bars 48 + tabs 32 + padding 14 + gaps 10 ≈ 127px)
   doesn't, so the dock overshot the carousel by ~12px. Tighten the shell's
   own padding + gaps and trim the stat bars so the content fits ~116px and
   the height lock holds. Standard/spacious are unaffected. */
:root[data-ui-density="compact"] .corner-dock-shell {
  padding: 3px 10px;
  gap: 2px;
}

:root[data-ui-density="compact"] .corner-dock-bars {
  gap: 2px;
}

:root[data-ui-density="compact"] .corner-dock-bar {
  height: 20px;
}

.bls-tab-panel {
  position: absolute;
  left: 0;
  bottom: calc(100% + 8px);
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 8px 10px;
  background: rgba(10, 10, 14, 0.92);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.6);
  z-index: 20;
  max-height: min(360px, calc(100vh - 260px));
  transition: border-left-color 250ms ease;
  animation: bls-popover-in 180ms cubic-bezier(0.34, 1.56, 0.64, 1);
}

:root[data-ui-density="compact"] .bls-tab-panel,
:root[data-ui-density="compact"] .bls-action-popover--processing {
  max-height: min(360px, calc(100vh - 220px));
}

.bls-tab-panel--profile {
  border-left: 2px solid rgba(6, 182, 212, 0.55);
}

.bls-tab-panel--quests {
  border-left: 2px solid rgba(239, 68, 68, 0.55);
}

.bls-tab-panel--achievements {
  border-left: 2px solid rgba(251, 191, 36, 0.55);
}

.bls-tab-panel-body {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 2px 0;
  max-height: 340px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.12) transparent;
}

.bls-tab-panel-body::-webkit-scrollbar {
  width: 4px;
}

.bls-tab-panel-body::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.12);
  border-radius: 2px;
}

.bls-status-header.is-active {
  background: rgba(10, 10, 14, 0.85);
  color: #fff;
}

.bls-status-header--profile.is-active {
  border-left-color: rgba(103, 232, 249, 0.9);
  box-shadow: 0 4px 20px rgba(6, 182, 212, 0.18), 0 0 0 1px rgba(103, 232, 249, 0.15) inset;
}

.bls-status-header--quests.is-active {
  border-left-color: rgba(252, 165, 165, 0.9);
  box-shadow: 0 4px 20px rgba(239, 68, 68, 0.18), 0 0 0 1px rgba(252, 165, 165, 0.15) inset;
}

.bls-status-header--ach.is-active {
  border-left-color: rgba(253, 224, 71, 0.9);
  box-shadow: 0 4px 20px rgba(251, 191, 36, 0.18), 0 0 0 1px rgba(253, 224, 71, 0.15) inset;
}

.corner-dock-actions,
.corner-dock-tabs {
  display: flex;
  gap: 5px;
  flex-shrink: 0;
}


.corner-dock-actions > .bls-status-header--action {
  flex: 1 1;
  min-width: 0;
  height: 30px;
  padding: 0 8px;
  gap: 6px;
  justify-content: center;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

/* Elixir as 4th tab — matches tab pill aesthetic with green accent seam. */
.corner-dock-tabs > .bls-status-header--elixir {
  flex: 1 1;
  min-width: 0;
  height: 30px;
  padding: 0 6px;
  gap: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(36, 254, 159, 0.04);
  border: 1px solid rgba(36, 254, 159, 0.14);
  border-left: 2px solid rgba(36, 254, 159, 0.5);
  border-radius: 10px;
  color: #24fe9f;
  cursor: default;
  font-size: 11px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  transition: background 150ms ease;
}

.corner-dock-tabs > .bls-status-header--elixir .bls-status-tab-value {
  color: #24fe9f;
  font-size: 12px;
  font-weight: 700;
}

.corner-dock-tabs > .bls-status-header--elixir .elixir-amount {
  gap: 0;
  color: inherit;
  font: inherit;
}

.corner-dock-tabs > .bls-status-header--elixir .elixir-amount svg {
  display: none;
}

.bls-status-elixir-value {
  font-size: 13px;
  font-weight: 800;
  color: #24fe9f;
  letter-spacing: 0.01em;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  gap: 3px;
}

.bls-status-elixir-value .elixir-amount {
  color: inherit;
  font-size: inherit;
  font-weight: inherit;
  gap: 3px;
}

.bls-status-elixir-value .elixir-amount svg {
  width: 13px;
  height: 13px;
}

.bls-status-header--elixir.is-animating {
  animation: elixir-pulse 450ms ease-out;
}

@keyframes elixir-pulse {
  0%   { transform: scale(1); background: rgba(36, 254, 159, 0.04); }
  50%  { transform: scale(1.04); background: rgba(36, 254, 159, 0.18); }
  100% { transform: scale(1); background: rgba(36, 254, 159, 0.04); }
}

.bls-status-action-label {
  font-weight: 700;
  letter-spacing: 0.06em;
  color: rgba(255, 255, 255, 0.85);
  text-transform: uppercase;
  font-size: 10px;
  line-height: 1;
}

.corner-dock-tabs > .bls-status-header {
  flex: 1 1;
  min-width: 0;
  height: 30px;
  padding: 0 6px;
  gap: 5px;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: none;
}

.corner-dock-tabs > .bls-status-header .bls-status-header-icon {
  flex-shrink: 0;
}

.bls-status-tab-value {
  font-variant-numeric: tabular-nums;
  color: rgba(255, 255, 255, 0.92);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.01em;
  line-height: 1;
}

.bls-status-header--quests .bls-status-tab-value { color: #fecaca; }
.bls-status-header--ach .bls-status-tab-value { color: #fde68a; }
.bls-status-header--profile .bls-status-tab-value { color: #67e8f9; }

/* Compact density: finish the dock height lock by tightening the two pill rows. */
:root[data-ui-density="compact"] .corner-dock-actions,
:root[data-ui-density="compact"] .corner-dock-tabs {
  gap: 4px;
}

:root[data-ui-density="compact"] .corner-dock-actions > .bls-status-header--action,
:root[data-ui-density="compact"] .corner-dock-tabs > .bls-status-header,
:root[data-ui-density="compact"] .corner-dock-tabs > .bls-status-header--elixir {
  height: 26px;
  min-height: 26px;
  padding: 0 5px;
  gap: 4px;
  border-radius: 8px;
}

:root[data-ui-density="compact"] .corner-dock-actions > .bls-status-header--action,
:root[data-ui-density="compact"] .corner-dock-actions > .bls-status-header--action .bls-status-action-label,
:root[data-ui-density="compact"] .corner-dock-tabs > .bls-status-header,
:root[data-ui-density="compact"] .corner-dock-tabs > .bls-status-header--elixir {
  font-size: 10px;
}

:root[data-ui-density="compact"] .corner-dock-tabs > .bls-status-header .bls-status-tab-value,
:root[data-ui-density="compact"] .corner-dock-tabs > .bls-status-header--elixir .bls-status-tab-value {
  font-size: 11px;
}

/* HP + XP as two individual pill chips sitting side-by-side in a single row,
   matching the action / tab pill rhythm (dark bg, hairline border, pill radius). */
.corner-dock-bars {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex-shrink: 0;
}

.corner-dock-bar {
  display: flex;
  align-items: center;
  gap: 7px;
  width: 100%;
  min-width: 0;
  height: 22px;
  padding: 0 8px;
  appearance: none;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 8px;
  color: inherit;
  text-align: left;
  font: inherit;
  transition: background 150ms ease, border-color 150ms ease;
}

.corner-dock-bar--hp {
  cursor: pointer;
  border-left: 2px solid rgba(34, 197, 94, 0.45);
}

.corner-dock-bar--hp:hover {
  background: rgba(34, 197, 94, 0.06);
  border-color: rgba(34, 197, 94, 0.22);
  border-left-color: rgba(34, 197, 94, 0.75);
}

.corner-dock-bar--hp.is-active {
  background: rgba(34, 197, 94, 0.1);
  border-color: rgba(34, 197, 94, 0.3);
  border-left-color: rgba(34, 197, 94, 0.9);
}

.corner-dock-bar--xp {
  border-left: 2px solid rgba(168, 85, 247, 0.45);
}

.corner-dock-bar--hp.is-dead {
  border-left-color: rgba(239, 68, 68, 0.7);
}

.corner-dock-bar-icon {
  flex-shrink: 0;
}

.corner-dock-bar--hp .corner-dock-bar-icon {
  color: #4ade80;
}

.corner-dock-bar--xp .corner-dock-bar-icon {
  color: #c084fc;
}

.corner-dock-bar--hp.is-dead .corner-dock-bar-icon {
  color: #f87171;
}

.corner-dock-bar-track {
  flex: 1 1;
  min-width: 0;
  height: 4px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 2px;
  overflow: hidden;
  position: relative;
}

.corner-dock-bar-fill {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  border-radius: 2px;
  transition: width 400ms cubic-bezier(0.34, 1.56, 0.64, 1), background 300ms ease;
}

.corner-dock-bar-fill--hp {
  background: #22c55e;
}

.corner-dock-bar--hp.is-dead .corner-dock-bar-fill--hp {
  background: #ef4444;
}

.corner-dock-bar-fill--xp {
  background: #a855f7;
}

.corner-dock-bar-value {
  font-size: 9.5px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.02em;
  flex-shrink: 0;
  min-width: 44px;
  text-align: right;
}

:root[data-ui-density="compact"] .corner-dock-bar-value {
  min-width: 36px;
  font-size: 9px;
  letter-spacing: 0.01em;
}

.corner-dock-bar-value--hp {
  color: rgba(134, 239, 172, 0.95);
}

.corner-dock-bar--hp.is-dead .corner-dock-bar-value--hp {
  color: rgba(252, 165, 165, 0.95);
}

/* Indigo Mantle (Methylene Blue) — overworld invincibility (bar fill only, no halo) */
.corner-dock-bar--hp.is-invincible .corner-dock-bar-fill--hp {
  background: linear-gradient(90deg, #3b82f6, #60a5fa, #93c5fd);
  animation: indigo-mantle-shimmer 2.4s ease-in-out infinite;
}

.corner-dock-bar--hp.is-invincible .corner-dock-bar-icon {
  color: #93c5fd;
}

.corner-dock-bar--hp.is-invincible .corner-dock-bar-value--hp {
  color: rgba(191, 219, 254, 0.98);
  font-size: 14px;
  letter-spacing: 0;
}

:root[data-ui-density="compact"] .corner-dock-bar--hp.is-invincible .corner-dock-bar-value--hp {
  min-width: 36px;
  font-size: 12px;
}

@keyframes indigo-mantle-shimmer {
  0%, 100% { filter: brightness(1); }
  50% { filter: brightness(1.25); }
}

.corner-dock-bar-value--xp {
  color: rgba(192, 132, 252, 0.92);
}

.bls-action-popover {
  position: absolute;
  left: 0;
  bottom: calc(100% + 8px);
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
  background: rgba(10, 10, 14, 0.96);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.65);
  z-index: 20;
  animation: bls-popover-in 180ms cubic-bezier(0.34, 1.56, 0.64, 1);
}

.bls-action-popover--upload {
  border-left: 2px solid rgba(129, 140, 248, 0.55);
}

.bls-action-popover--processing {
  border-left: 2px solid rgba(129, 140, 248, 0.55);
  max-height: min(360px, calc(100vh - 260px));
  overflow-y: auto;
}

.bls-action-popover--hp {
  border-left: 2px solid rgba(34, 197, 94, 0.55);
}

@keyframes bls-popover-in {
  from { opacity: 0; transform: translateY(-6px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Upload / HP chips — mirror map-quest-chip language so popovers feel native. */
.map-upload-chip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  width: 100%;
  background: rgba(10, 10, 14, 0.6);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-left: 2px solid rgba(129, 140, 248, 0.7);
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
  cursor: pointer;
  text-align: left;
  transition: border-color 150ms ease, background 150ms ease;
}

.map-upload-chip:hover {
  background: rgba(10, 10, 14, 0.75);
  border-color: rgba(129, 140, 248, 0.3);
  border-left-color: rgba(165, 180, 252, 0.95);
}

.map-upload-chip--disabled,
.map-upload-chip:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  background: rgba(10, 10, 14, 0.45);
  border-color: rgba(255, 255, 255, 0.05);
  border-left-color: rgba(255, 255, 255, 0.12);
  box-shadow: none;
}

.map-upload-chip--disabled .map-upload-chip-icon,
.map-upload-chip:disabled .map-upload-chip-icon {
  color: rgba(255, 255, 255, 0.38);
  background: rgba(255, 255, 255, 0.06);
}

.map-upload-chip-icon {
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 5px;
  color: rgba(165, 180, 252, 0.95);
  background: rgba(129, 140, 248, 0.15);
}

.map-upload-chip-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.map-upload-chip-name {
  font-size: 10.5px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.88);
  letter-spacing: 0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.map-upload-chip-sub {
  font-size: 9px;
  font-weight: 600;
  color: rgba(165, 180, 252, 0.7);
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.map-upload-chip-body--processing {
  gap: 0;
}

.map-upload-chip--processing-upload {
  border-left-color: rgba(245, 158, 11, 0.72);
}

.map-upload-chip--processing-upload:hover {
  border-color: rgba(245, 158, 11, 0.24);
  border-left-color: rgba(252, 211, 77, 0.96);
}

.map-upload-chip--processing-concept {
  border-left-color: rgba(59, 130, 246, 0.72);
}

.map-upload-chip--processing-concept:hover {
  border-color: rgba(59, 130, 246, 0.24);
  border-left-color: rgba(96, 165, 250, 0.96);
}

.bls-processing-icon--upload {
  color: rgba(254, 240, 138, 0.95);
  background: rgba(245, 158, 11, 0.16);
}

.bls-processing-icon--concept {
  color: rgba(191, 219, 254, 0.95);
  background: rgba(59, 130, 246, 0.16);
}

.bls-processing-spinner {
  display: block;
  animation: bls-processing-spin 0.9s linear infinite;
}

.bls-processing-value {
  flex-shrink: 0;
  font-size: 9.5px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.02em;
}

.bls-processing-value--upload {
  color: rgba(254, 240, 138, 0.95);
}

.bls-processing-value--concept {
  color: rgba(191, 219, 254, 0.95);
}

@keyframes bls-processing-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* HP chips */
.map-hp-chip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  background: rgba(10, 10, 14, 0.6);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-left: 2px solid rgba(34, 197, 94, 0.7);
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
}

.map-hp-chip--warn {
  border-left-color: rgba(251, 191, 36, 0.8);
}

.map-hp-chip--danger {
  border-left-color: rgba(239, 68, 68, 0.85);
}

.map-hp-chip-icon {
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 5px;
  color: rgba(134, 239, 172, 0.95);
  background: rgba(34, 197, 94, 0.15);
}

.map-hp-chip-icon--warn {
  color: rgba(253, 224, 71, 0.95);
  background: rgba(251, 191, 36, 0.15);
}

.map-hp-chip-icon--danger {
  color: rgba(252, 165, 165, 0.95);
  background: rgba(239, 68, 68, 0.18);
}

.map-hp-chip-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.map-hp-chip-name {
  font-size: 10.5px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.88);
  letter-spacing: 0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.map-hp-chip-sub {
  font-size: 9px;
  font-weight: 600;
  color: rgba(134, 239, 172, 0.7);
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.map-hp-chip--warn .map-hp-chip-sub {
  color: rgba(253, 224, 71, 0.75);
}

.map-hp-chip--danger .map-hp-chip-sub {
  color: rgba(252, 165, 165, 0.85);
}

.map-hp-chip-bar {
  height: 2px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 1px;
  overflow: hidden;
}

.map-hp-chip-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #22c55e, #4ade80);
  border-radius: 1px;
  transition: width 400ms ease;
}

.map-hp-chip-value {
  font-size: 9.5px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  color: rgba(134, 239, 172, 0.95);
  letter-spacing: 0.02em;
  flex-shrink: 0;
}

.bls-status-header--hp {
  border-left: 2px solid rgba(34, 197, 94, 0.55);
  cursor: pointer;
  gap: 8px;
}

.bls-status-header--hp .bls-status-header-icon {
  color: rgba(134, 239, 172, 0.95);
}

.bls-status-header--hp.is-dead {
  border-left-color: rgba(239, 68, 68, 0.7);
}

.bls-status-header--hp.is-dead .bls-status-header-icon {
  color: rgba(252, 165, 165, 0.95);
}

.bls-hp-bar {
  flex: 1 1;
  min-width: 0;
  height: 4px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 2px;
  overflow: hidden;
}

.bls-hp-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #22c55e, #4ade80);
  border-radius: 2px;
  transition: width 400ms ease, background 300ms ease;
}

.bls-status-header--hp.is-dead .bls-hp-bar-fill {
  background: linear-gradient(90deg, #ef4444, #fca5a5);
}

.bls-hp-value {
  font-size: 9.5px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  color: rgba(134, 239, 172, 0.95);
  letter-spacing: 0.02em;
  flex-shrink: 0;
}

.bls-status-header--hp.is-dead .bls-hp-value {
  color: rgba(252, 165, 165, 0.95);
}

.bls-status-header--wand {
  border-left: 2px solid rgba(148, 163, 184, 0.35);
}

.bls-status-header--wand .bls-status-header-icon {
  color: rgba(148, 163, 184, 0.8);
}

.bls-status-header--wand.is-active {
  border-left-color: var(--accent-primary, #ef4444);
  background: rgba(239, 68, 68, 0.14);
}

.bls-status-header--wand.is-active .bls-status-header-icon,
.bls-status-header--wand.is-active .bls-status-label {
  color: #fca5a5;
}

.bls-status-header--wand.has-glow {
  box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.38), 0 0 14px rgba(239, 68, 68, 0.35);
  animation: wand-pulse 2.4s ease-in-out infinite;
}

.bls-status-header--wand.has-glow .bls-status-header-icon,
.bls-status-header--wand.has-glow .bls-status-label {
  color: #fca5a5;
}

@keyframes wand-pulse {
  0%, 100% { box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.3), 0 0 10px rgba(239, 68, 68, 0.25); }
  50%      { box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.55), 0 0 20px rgba(239, 68, 68, 0.5); }
}

.bls-status-header.is-disabled {
  opacity: 0.4;
  cursor: not-allowed;
  color: rgba(255, 255, 255, 0.5);
}

.bls-status-header.is-disabled:hover {
  background: rgba(10, 10, 14, 0.68);
  color: rgba(255, 255, 255, 0.5);
}

.bls-status-muted-tag {
  margin-left: auto;
  padding: 1px 6px;
  border-radius: 6px;
  background: rgba(148, 163, 184, 0.15);
  color: rgba(148, 163, 184, 0.9);
  font-size: 8.5px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.bls-status-header--upload {
  border-left: 2px solid rgba(129, 140, 248, 0.55);
}

.bls-status-header--upload .bls-status-header-icon {
  color: rgba(165, 180, 252, 0.95);
}

.bls-status-header--upload:hover {
  border-left-color: rgba(165, 180, 252, 0.85);
}

.bls-status-header {
  appearance: none;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 7px 10px;
  background: rgba(10, 10, 14, 0.68);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.45);
  cursor: pointer;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.78);
  transition: background 150ms ease, color 150ms ease, border-color 150ms ease;
  text-align: left;
  justify-content: flex-start;
}

.bls-status-header:hover {
  background: rgba(10, 10, 14, 0.78);
  color: #fff;
}

.bls-status-header--icon-only {
  max-width: 32px;
  height: 32px;
  padding: 0;
  justify-content: center;
  border-radius: 8px;
}

.bls-status-header--icon-only .bls-status-header-icon {
  width: 14px;
  height: 14px;
}

.bls-status-header--dock-hp {
  min-height: 26px;
  padding-top: 6px;
  padding-bottom: 6px;
}

.bls-status-header--tab {
  min-height: 32px;
  padding: 7px 8px;
  gap: 6px;
}

.bls-status-header--quests {
  border-left: 2px solid rgba(239, 68, 68, 0.55);
}

.bls-status-header--ach {
  border-left: 2px solid rgba(251, 191, 36, 0.55);
}

.bls-status-header--profile {
  border-left: 2px solid rgba(6, 182, 212, 0.55);
}

.bls-status-header--quests .bls-status-header-icon {
  color: rgba(252, 165, 165, 0.95);
}

.bls-status-header--ach .bls-status-header-icon {
  color: rgba(251, 191, 36, 0.95);
}

.bls-status-header--profile .bls-status-header-icon {
  color: rgba(103, 232, 249, 0.95);
}

.bls-status-profile-inline {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex: 1 1;
  min-width: 0;
  justify-content: flex-end;
  margin-left: 2px;
}

.profile-inline-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 7px;
  border-radius: 6px;
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.04em;
  font-variant-numeric: tabular-nums;
  line-height: 1.2;
}

.profile-inline-chip--lv {
  background: rgba(6, 182, 212, 0.16);
  color: #67e8f9;
  border: 1px solid rgba(6, 182, 212, 0.28);
}

.profile-inline-chip--elixir {
  background: rgba(36, 254, 159, 0.12);
  color: #24fe9f;
  border: 1px solid rgba(36, 254, 159, 0.25);
}

.profile-inline-chip--elixir .elixir-amount {
  font-size: inherit;
}

.bls-status-label {
  flex: 1 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bls-status-count {
  min-width: 16px;
  padding: 0 6px;
  height: 15px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  line-height: 1;
  border-radius: 8px;
  font-variant-numeric: tabular-nums;
}

.bls-status-header--quests .bls-status-count {
  color: #fecaca;
  background: rgba(239, 68, 68, 0.18);
  border: 1px solid rgba(239, 68, 68, 0.3);
}

.bls-status-header--ach .bls-status-count {
  color: #fde68a;
  background: rgba(251, 191, 36, 0.18);
  border: 1px solid rgba(251, 191, 36, 0.3);
}

.bls-status-chevron {
  color: rgba(255, 255, 255, 0.4);
  transition: transform 150ms ease;
  flex-shrink: 0;
  transform: rotate(180deg);
}

.bls-status-chevron.collapsed {
  transform: rotate(0deg);
}

.bls-status-overlay {
  position: absolute;
  bottom: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: calc(100vh - 240px);
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.12) transparent;
}

:root[data-ui-density="compact"] .bls-status-overlay {
  max-height: calc(100vh - 204px);
}

.bls-status-overlay::-webkit-scrollbar {
  width: 4px;
}

.bls-status-overlay::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.12);
  border-radius: 2px;
}

.bls-status-panel {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 6px;
  background: rgba(10, 10, 14, 0.72);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.55);
}

.bls-status-panel--quests {
  border-left: 2px solid rgba(239, 68, 68, 0.55);
}

.bls-status-panel--ach {
  border-left: 2px solid rgba(251, 191, 36, 0.55);
}

.bls-status-panel--profile {
  border-left: 2px solid rgba(6, 182, 212, 0.55);
  padding: 10px 10px 8px;
  gap: 6px;
}

.profile-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 4px;
  border-radius: 6px;
  transition: background 150ms ease;
}

.profile-row--cards {
  cursor: pointer;
}

.profile-row--cards:hover {
  background: rgba(255, 255, 255, 0.04);
}

.profile-row-icon {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
}

.profile-row-icon--honor {
  color: #fde68a;
  background: rgba(251, 191, 36, 0.14);
}

.profile-row-icon--elixir {
  color: #24fe9f;
  background: rgba(36, 254, 159, 0.12);
}

.profile-row-icon--cards {
  color: #93c5fd;
  background: rgba(59, 130, 246, 0.14);
}

.profile-row-label {
  flex: 1 1;
  min-width: 0;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: rgba(255, 255, 255, 0.74);
  text-transform: uppercase;
  white-space: nowrap;
}

.profile-row-value {
  font-size: 15px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.92);
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.02em;
}

.profile-row--elixir .profile-row-value {
  color: #24fe9f;
}

.profile-row--level {
  padding: 7px 4px;
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 8px;
  align-items: center;
}

.profile-row-level-badge {
  padding: 2px 8px;
  border-radius: 6px;
  background: rgba(6, 182, 212, 0.15);
  color: #67e8f9;
  border: 1px solid rgba(6, 182, 212, 0.3);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  font-variant-numeric: tabular-nums;
}

.profile-row-bar {
  height: 4px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 2px;
  overflow: hidden;
}

.profile-row-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #06b6d4, #67e8f9);
  border-radius: 2px;
  transition: width 400ms ease;
}

.profile-row--level .profile-row-value {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.58);
  letter-spacing: 0.04em;
}

.profile-row--pop .profile-row-value {
  animation: profile-pop 320ms ease;
}

@keyframes profile-pop {
  0% { transform: scale(1); }
  40% { transform: scale(1.14); }
  100% { transform: scale(1); }
}

.profile-breakdown {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 6px 2px;
  gap: 10px;
}

.profile-card-stat {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 10.5px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.78);
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.02em;
}

.profile-card-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
}

.profile-card-count {
  min-width: 1.4ch;
  text-align: left;
}

.profile-donut {
  display: block;
}

.bls-status-panel .map-quest-chip,
.bls-status-panel .map-ach-chip {
  background: rgba(255, 255, 255, 0.02);
  box-shadow: none;
}

.bls-status-panel .map-quest-chip:hover,
.bls-status-panel .map-ach-chip:hover {
  background: rgba(255, 255, 255, 0.05);
}

.map-quest-chip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  background: rgba(10, 10, 14, 0.6);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-left: 2px solid rgba(239, 68, 68, 0.7);
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
  transition: border-color 150ms ease, background 150ms ease;
}

.map-quest-chip:hover {
  background: rgba(10, 10, 14, 0.75);
  border-color: rgba(239, 68, 68, 0.3);
  border-left-color: rgba(252, 165, 165, 0.9);
}

.map-quest-chip--done {
  border-left-color: rgba(74, 222, 128, 0.9);
  opacity: 0.82;
}

.map-quest-chip-icon {
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 5px;
  color: rgba(252, 165, 165, 0.9);
  background: rgba(239, 68, 68, 0.1);
}

.map-quest-chip-icon.review {
  color: #818cf8;
  background: rgba(99, 102, 241, 0.15);
}

.map-quest-chip-icon.train,
.map-quest-chip-icon.drug_drill,
.map-quest-chip-icon.tend_drugs {
  color: #fbbf24;
  background: rgba(245, 158, 11, 0.15);
}

.map-quest-chip-icon.learn,
.map-quest-chip-icon.learn_level,
.map-quest-chip-icon.annex_drugs {
  color: #4ade80;
  background: rgba(34, 197, 94, 0.15);
}

.map-quest-chip-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.map-quest-chip-name {
  font-size: 10.5px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.88);
  letter-spacing: 0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.map-quest-chip-bar {
  height: 2px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 1px;
  overflow: hidden;
}

.map-quest-chip-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #ef4444, #fca5a5);
  border-radius: 1px;
  transition: width 300ms ease;
}

.map-quest-chip--done .map-quest-chip-bar-fill {
  background: linear-gradient(90deg, #22c55e, #4ade80);
}

.map-quest-chip-bounty {
  font-size: 9.5px;
  font-weight: 700;
  color: rgba(74, 222, 128, 0.85);
  letter-spacing: 0.04em;
  font-variant-numeric: tabular-nums;
  flex-shrink: 0;
}

.map-quest-chip-check {
  color: #4ade80;
  font-size: 13px;
  line-height: 1;
}

.map-ach-chip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  background: rgba(10, 10, 14, 0.6);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-left: 2px solid rgba(251, 191, 36, 0.7);
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
  transition: border-color 150ms ease, background 150ms ease;
}

.map-ach-chip:hover {
  background: rgba(10, 10, 14, 0.75);
  border-color: rgba(251, 191, 36, 0.3);
  border-left-color: rgba(253, 224, 71, 0.9);
}

.map-ach-chip-icon {
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fbbf24;
  flex-shrink: 0;
}

.map-ach-chip-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.map-ach-chip-name {
  font-size: 10.5px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.88);
  letter-spacing: 0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.map-ach-chip-bar {
  height: 2px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 1px;
  overflow: hidden;
}

.map-ach-chip-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #f59e0b, #fbbf24);
  border-radius: 1px;
  transition: width 300ms ease;
}

.map-ach-chip-progress {
  font-size: 9.5px;
  font-weight: 600;
  color: rgba(253, 224, 71, 0.75);
  letter-spacing: 0.04em;
  font-variant-numeric: tabular-nums;
  flex-shrink: 0;
}


/* ─── Wand Popover ─────────────────────────────────────────────
   Reuses .bls-action-popover + .map-upload-chip styles so it matches
   the Upload / HP / Quest popovers exactly. Differs only in:
     1. Position: pops out to the RIGHT of the BLS dock (not above),
        so it doesn't cover the HP bars.
     2. Left-border accent + icon tint: warm amber for wand identity.
*/

/* Wand popover pops out to the RIGHT of the entire BLS dock.
   Anchored to .corner-dock-shell (same positioning ancestor as
   .bls-action-popover--upload) so its edges align with the dock
   exactly — top + bottom flush with the shell, left flush with the
   shell's right edge + 8px gutter. Internal padding + chip sizes
   are tightened so 3 chips fit inside the dock's height cleanly. */
.bls-action-popover--wand {
  left: calc(100% + 8px);
  right: auto;
  top: 0;
  bottom: 0;
  width: 200px;
  padding: 5px;
  gap: 3px;
  border-left: 2px solid rgba(239, 68, 68, 0.6);
  animation: bls-popover-right-in 180ms cubic-bezier(0.34, 1.56, 0.64, 1);
}

.bls-action-popover--wand .map-upload-chip {
  flex: 1 1;
  min-height: 0;
  padding: 4px 8px;
}

.bls-action-popover--wand .map-upload-chip-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

@keyframes bls-popover-right-in {
  from { opacity: 0; transform: translateX(-6px); }
  to   { opacity: 1; transform: translateX(0); }
}

/* Wand chip — neutral shell; per-action subaccents provide the color.
   The popover box itself carries the red main accent. */
.map-upload-chip--wand {
  border-left-color: rgba(239, 68, 68, 0.35);
}

.map-upload-chip--wand:hover {
  border-color: rgba(239, 68, 68, 0.2);
}

/* Forge — orange */
.map-upload-chip--forge {
  border-left-color: rgba(245, 158, 11, 0.75);
}
.map-upload-chip--forge:hover {
  border-color: rgba(245, 158, 11, 0.3);
  border-left-color: rgba(251, 191, 36, 0.95);
}
.map-upload-chip--forge .map-upload-chip-icon {
  color: rgba(251, 191, 36, 0.95);
  background: rgba(245, 158, 11, 0.15);
}
.map-upload-chip--forge .map-upload-chip-sub {
  color: rgba(251, 191, 36, 0.7);
}

/* Vault — purple */
.map-upload-chip--vault {
  border-left-color: rgba(167, 139, 250, 0.75);
}
.map-upload-chip--vault:hover {
  border-color: rgba(167, 139, 250, 0.3);
  border-left-color: rgba(196, 181, 253, 0.95);
}
.map-upload-chip--vault .map-upload-chip-icon {
  color: rgba(196, 181, 253, 0.95);
  background: rgba(167, 139, 250, 0.15);
}
.map-upload-chip--vault .map-upload-chip-sub {
  color: rgba(196, 181, 253, 0.7);
}

/* Cheat Sheet — cyan */
.map-upload-chip--cheatsheet {
  border-left-color: rgba(34, 211, 238, 0.75);
}
.map-upload-chip--cheatsheet:hover {
  border-color: rgba(34, 211, 238, 0.3);
  border-left-color: rgba(103, 232, 249, 0.95);
}
.map-upload-chip--cheatsheet .map-upload-chip-icon {
  color: rgba(103, 232, 249, 0.95);
  background: rgba(34, 211, 238, 0.15);
}
.map-upload-chip--cheatsheet .map-upload-chip-sub {
  color: rgba(103, 232, 249, 0.7);
}
`, "",{"version":3,"sources":["webpack://./src/components/BottomLeftStatusRail/BottomLeftStatusRail.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,OAAO;EACP;;;;;;;;;;;;;+CAa6C;EAC7C,0CAA0C;EAC1C,kCAAkC;EAClC;;;;4FAI0F;EAC1F,YAAY;EACZ,iBAAiB;EACjB;;;;;8CAK4C;EAC5C,kCAAkC;EAClC,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe,aAAa,EAAE,EAAE,mCAAmC;AACrE;;AAEA;;;mEAGmE;AACnE;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,+CAA+C;EAC/C,iDAAiD;EACjD,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;;;;6DAI6D;AAC7D;EACE,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,wBAAwB;EACxB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,yCAAyC;EACzC,WAAW;EACX,2CAA2C;EAC3C,wCAAwC;EACxC,iEAAiE;AACnE;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,2CAA2C;EAC3C,yFAAyF;AAC3F;;AAEA;EACE,2CAA2C;EAC3C,yFAAyF;AAC3F;;AAEA;EACE,0CAA0C;EAC1C,yFAAyF;AAC3F;;AAEA;;EAEE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;;AAGA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,QAAQ;EACR,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,2EAA2E;AAC3E;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,0CAA0C;EAC1C,8CAA8C;EAC9C,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,MAAM;EACN,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,OAAO,mBAAmB,EAAE,oCAAoC,EAAE;EAClE,OAAO,sBAAsB,EAAE,oCAAoC,EAAE;EACrE,OAAO,mBAAmB,EAAE,oCAAoC,EAAE;AACpE;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;EAChC,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,QAAQ;EACR,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA,mDAAmD,cAAc,EAAE;AACnE,gDAAgD,cAAc,EAAE;AAChE,oDAAoD,cAAc,EAAE;;AAEpE,kFAAkF;AAClF;;EAEE,QAAQ;AACV;;AAEA;;;EAGE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,QAAQ;EACR,kBAAkB;AACpB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;mFACmF;AACnF;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,0DAA0D;AAC5D;;AAEA;EACE,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,kBAAkB;EAClB,gFAAgF;AAClF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,sFAAsF;AACtF;EACE,6DAA6D;EAC7D,0DAA0D;AAC5D;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW,qBAAqB,EAAE;EAClC,MAAM,wBAAwB,EAAE;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,wBAAwB;EACxB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,iEAAiE;AACnE;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;EAChD,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,WAAW;EACX,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;EAC3C,+CAA+C;EAC/C,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,4CAA4C;AAC9C;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,uCAAuC;EACvC,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;;EAEE,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,+BAA+B;EAC/B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;EAC3C,6CAA6C;EAC7C,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,+BAA+B;EAC/B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,gCAAgC;EAChC,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,8CAA8C;EAC9C,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,gCAAgC;EAChC,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iDAAiD;EACjD,mCAAmC;AACrC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,+EAA+E;EAC/E,+CAA+C;AACjD;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW,8EAA8E,EAAE;EAC3F,WAAW,8EAA8E,EAAE;AAC7F;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;EAC3C,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,4EAA4E;EAC5E,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;EAC3C,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,8CAA8C;EAC9C,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;EAChC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,oCAAoC;EACpC,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,KAAK,mBAAmB,EAAE;EAC1B,MAAM,sBAAsB,EAAE;EAC9B,OAAO,mBAAmB,EAAE;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;EAC3C,6CAA6C;EAC7C,kBAAkB;EAClB,0CAA0C;EAC1C,0DAA0D;AAC5D;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;;;EAGE,cAAc;EACd,oCAAoC;AACtC;;AAEA;;;EAGE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,sBAAsB;EACtB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;EAC3C,8CAA8C;EAC9C,kBAAkB;EAClB,0CAA0C;EAC1C,0DAA0D;AAC5D;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,sBAAsB;EACtB,kCAAkC;EAClC,cAAc;AAChB;;;AAGA;;;;;;CAMC;;AAED;;;;;mEAKmE;AACnE;EACE,sBAAsB;EACtB,WAAW;EACX,MAAM;EACN,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,QAAQ;EACR,6CAA6C;EAC7C,uEAAuE;AACzE;;AAEA;EACE,SAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;wDACwD;AACxD;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA,mBAAmB;AACnB;EACE,2CAA2C;AAC7C;AACA;EACE,qCAAqC;EACrC,2CAA2C;AAC7C;AACA;EACE,+BAA+B;EAC/B,oCAAoC;AACtC;AACA;EACE,8BAA8B;AAChC;;AAEA,mBAAmB;AACnB;EACE,4CAA4C;AAC9C;AACA;EACE,sCAAsC;EACtC,4CAA4C;AAC9C;AACA;EACE,gCAAgC;EAChC,qCAAqC;AACvC;AACA;EACE,+BAA+B;AACjC;;AAEA,uBAAuB;AACvB;EACE,2CAA2C;AAC7C;AACA;EACE,qCAAqC;EACrC,4CAA4C;AAC9C;AACA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;AACA;EACE,+BAA+B;AACjC","sourcesContent":[".corner-dock {\n  position: fixed;\n  left: 0;\n  /* Bottom offset still mirrors the sticky carousel so the dock sits in the\n     same bottom strip on every scroll state. Height is content-sized via\n     min-height (NOT locked to --carousel-height anymore — 2026-05-19) so\n     the dock's interior layout always fits its rows without space-between\n     distributing visible gaps and without the bottom row overflowing on\n     routes where the carousel is shorter than the rows need (e.g., /map\n     measured 120px which clipped the tabs row).\n\n     min-height per density matches the natural sum of rows + padding + gap:\n     standard = 30 (actions) + 48 (bars) + 32 (tabs) + 14 (padding) + 10 (gap) = 134\n     compact  = 26 + 42 + 26 + 6 + 4 = 104 (overridden below)\n\n     If a future design pairs the dock to the carousel band again, restore\n     `height: var(--carousel-height, 140px)`. */\n  bottom: var(--carousel-bottom-offset, 0px);\n  width: var(--sidebar-width, 280px);\n  /* min-height matches --carousel-tray-height so dock and carousel sit\n     flush along their top edge. The token (140 standard / 110 compact)\n     leaves ~6-10px breathing over the natural content floor so\n     space-between distributes visible gaps between rows instead of\n     packing them flush. See wiki/decisions/2026-05-19-dock-carousel-sidebar-proportion.md */\n  height: auto;\n  min-height: 140px;\n  /* Paint the dock with the same shell bg so any rounding gap between\n     dock min-height (140px) and shell content height (~135px) doesn't\n     expose the sidebar TOC text behind the fixed dock. The shell's\n     `height: 100%` cannot resolve against the auto-height dock and\n     collapses to content height, leaving a transparent strip at the\n     dock's bottom edge — Edward 2026-05-27. */\n  background: rgba(10, 10, 10, 0.94);\n  z-index: 45;\n  pointer-events: none;\n}\n\n:root[data-ui-density=\"compact\"] .corner-dock {\n  min-height: 110px;\n}\n\n@media (max-width: 768px) {\n  .corner-dock { display: none; } /* follows sidebar hide-on-mobile */\n}\n\n/* The dock is the bottom of the left column (width-locked to --sidebar-width).\n   When the sidebar is collapsed it would shrink to a 0-width box with its shell\n   content spilling over the main area, so hide it outright. display:none is safe\n   because a collapsed sidebar has no open dock popovers to clip. */\n:root[data-sidebar-collapsed=\"true\"] .corner-dock {\n  display: none;\n}\n\n.corner-dock-shell {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 5px;\n  padding: 7px 10px;\n  background: rgba(10, 10, 10, 0.94);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  border-right: 1px solid rgba(255, 255, 255, 0.08);\n  pointer-events: auto;\n  box-shadow: 0 -14px 32px rgba(0, 0, 0, 0.42);\n}\n\n/* Compact density: the carousel shrinks to ~116px but the dock's 3-row\n   content (actions 30 + bars 48 + tabs 32 + padding 14 + gaps 10 ≈ 127px)\n   doesn't, so the dock overshot the carousel by ~12px. Tighten the shell's\n   own padding + gaps and trim the stat bars so the content fits ~116px and\n   the height lock holds. Standard/spacious are unaffected. */\n:root[data-ui-density=\"compact\"] .corner-dock-shell {\n  padding: 3px 10px;\n  gap: 2px;\n}\n\n:root[data-ui-density=\"compact\"] .corner-dock-bars {\n  gap: 2px;\n}\n\n:root[data-ui-density=\"compact\"] .corner-dock-bar {\n  height: 20px;\n}\n\n.bls-tab-panel {\n  position: absolute;\n  left: 0;\n  bottom: calc(100% + 8px);\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 8px 10px;\n  background: rgba(10, 10, 14, 0.92);\n  backdrop-filter: blur(14px);\n  -webkit-backdrop-filter: blur(14px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.6);\n  z-index: 20;\n  max-height: min(360px, calc(100vh - 260px));\n  transition: border-left-color 250ms ease;\n  animation: bls-popover-in 180ms cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n:root[data-ui-density=\"compact\"] .bls-tab-panel,\n:root[data-ui-density=\"compact\"] .bls-action-popover--processing {\n  max-height: min(360px, calc(100vh - 220px));\n}\n\n.bls-tab-panel--profile {\n  border-left: 2px solid rgba(6, 182, 212, 0.55);\n}\n\n.bls-tab-panel--quests {\n  border-left: 2px solid rgba(239, 68, 68, 0.55);\n}\n\n.bls-tab-panel--achievements {\n  border-left: 2px solid rgba(251, 191, 36, 0.55);\n}\n\n.bls-tab-panel-body {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 2px 0;\n  max-height: 340px;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.12) transparent;\n}\n\n.bls-tab-panel-body::-webkit-scrollbar {\n  width: 4px;\n}\n\n.bls-tab-panel-body::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.12);\n  border-radius: 2px;\n}\n\n.bls-status-header.is-active {\n  background: rgba(10, 10, 14, 0.85);\n  color: #fff;\n}\n\n.bls-status-header--profile.is-active {\n  border-left-color: rgba(103, 232, 249, 0.9);\n  box-shadow: 0 4px 20px rgba(6, 182, 212, 0.18), 0 0 0 1px rgba(103, 232, 249, 0.15) inset;\n}\n\n.bls-status-header--quests.is-active {\n  border-left-color: rgba(252, 165, 165, 0.9);\n  box-shadow: 0 4px 20px rgba(239, 68, 68, 0.18), 0 0 0 1px rgba(252, 165, 165, 0.15) inset;\n}\n\n.bls-status-header--ach.is-active {\n  border-left-color: rgba(253, 224, 71, 0.9);\n  box-shadow: 0 4px 20px rgba(251, 191, 36, 0.18), 0 0 0 1px rgba(253, 224, 71, 0.15) inset;\n}\n\n.corner-dock-actions,\n.corner-dock-tabs {\n  display: flex;\n  gap: 5px;\n  flex-shrink: 0;\n}\n\n\n.corner-dock-actions > .bls-status-header--action {\n  flex: 1;\n  min-width: 0;\n  height: 30px;\n  padding: 0 8px;\n  gap: 6px;\n  justify-content: center;\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n/* Elixir as 4th tab — matches tab pill aesthetic with green accent seam. */\n.corner-dock-tabs > .bls-status-header--elixir {\n  flex: 1;\n  min-width: 0;\n  height: 30px;\n  padding: 0 6px;\n  gap: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(36, 254, 159, 0.04);\n  border: 1px solid rgba(36, 254, 159, 0.14);\n  border-left: 2px solid rgba(36, 254, 159, 0.5);\n  border-radius: 10px;\n  color: #24fe9f;\n  cursor: default;\n  font-size: 11px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  transition: background 150ms ease;\n}\n\n.corner-dock-tabs > .bls-status-header--elixir .bls-status-tab-value {\n  color: #24fe9f;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.corner-dock-tabs > .bls-status-header--elixir .elixir-amount {\n  gap: 0;\n  color: inherit;\n  font: inherit;\n}\n\n.corner-dock-tabs > .bls-status-header--elixir .elixir-amount svg {\n  display: none;\n}\n\n.bls-status-elixir-value {\n  font-size: 13px;\n  font-weight: 800;\n  color: #24fe9f;\n  letter-spacing: 0.01em;\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n}\n\n.bls-status-elixir-value .elixir-amount {\n  color: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  gap: 3px;\n}\n\n.bls-status-elixir-value .elixir-amount svg {\n  width: 13px;\n  height: 13px;\n}\n\n.bls-status-header--elixir.is-animating {\n  animation: elixir-pulse 450ms ease-out;\n}\n\n@keyframes elixir-pulse {\n  0%   { transform: scale(1); background: rgba(36, 254, 159, 0.04); }\n  50%  { transform: scale(1.04); background: rgba(36, 254, 159, 0.18); }\n  100% { transform: scale(1); background: rgba(36, 254, 159, 0.04); }\n}\n\n.bls-status-action-label {\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  color: rgba(255, 255, 255, 0.85);\n  text-transform: uppercase;\n  font-size: 10px;\n  line-height: 1;\n}\n\n.corner-dock-tabs > .bls-status-header {\n  flex: 1;\n  min-width: 0;\n  height: 30px;\n  padding: 0 6px;\n  gap: 5px;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-transform: none;\n}\n\n.corner-dock-tabs > .bls-status-header .bls-status-header-icon {\n  flex-shrink: 0;\n}\n\n.bls-status-tab-value {\n  font-variant-numeric: tabular-nums;\n  color: rgba(255, 255, 255, 0.92);\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  line-height: 1;\n}\n\n.bls-status-header--quests .bls-status-tab-value { color: #fecaca; }\n.bls-status-header--ach .bls-status-tab-value { color: #fde68a; }\n.bls-status-header--profile .bls-status-tab-value { color: #67e8f9; }\n\n/* Compact density: finish the dock height lock by tightening the two pill rows. */\n:root[data-ui-density=\"compact\"] .corner-dock-actions,\n:root[data-ui-density=\"compact\"] .corner-dock-tabs {\n  gap: 4px;\n}\n\n:root[data-ui-density=\"compact\"] .corner-dock-actions > .bls-status-header--action,\n:root[data-ui-density=\"compact\"] .corner-dock-tabs > .bls-status-header,\n:root[data-ui-density=\"compact\"] .corner-dock-tabs > .bls-status-header--elixir {\n  height: 26px;\n  min-height: 26px;\n  padding: 0 5px;\n  gap: 4px;\n  border-radius: 8px;\n}\n\n:root[data-ui-density=\"compact\"] .corner-dock-actions > .bls-status-header--action,\n:root[data-ui-density=\"compact\"] .corner-dock-actions > .bls-status-header--action .bls-status-action-label,\n:root[data-ui-density=\"compact\"] .corner-dock-tabs > .bls-status-header,\n:root[data-ui-density=\"compact\"] .corner-dock-tabs > .bls-status-header--elixir {\n  font-size: 10px;\n}\n\n:root[data-ui-density=\"compact\"] .corner-dock-tabs > .bls-status-header .bls-status-tab-value,\n:root[data-ui-density=\"compact\"] .corner-dock-tabs > .bls-status-header--elixir .bls-status-tab-value {\n  font-size: 11px;\n}\n\n/* HP + XP as two individual pill chips sitting side-by-side in a single row,\n   matching the action / tab pill rhythm (dark bg, hairline border, pill radius). */\n.corner-dock-bars {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.corner-dock-bar {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  width: 100%;\n  min-width: 0;\n  height: 22px;\n  padding: 0 8px;\n  appearance: none;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.07);\n  border-radius: 8px;\n  color: inherit;\n  text-align: left;\n  font: inherit;\n  transition: background 150ms ease, border-color 150ms ease;\n}\n\n.corner-dock-bar--hp {\n  cursor: pointer;\n  border-left: 2px solid rgba(34, 197, 94, 0.45);\n}\n\n.corner-dock-bar--hp:hover {\n  background: rgba(34, 197, 94, 0.06);\n  border-color: rgba(34, 197, 94, 0.22);\n  border-left-color: rgba(34, 197, 94, 0.75);\n}\n\n.corner-dock-bar--hp.is-active {\n  background: rgba(34, 197, 94, 0.1);\n  border-color: rgba(34, 197, 94, 0.3);\n  border-left-color: rgba(34, 197, 94, 0.9);\n}\n\n.corner-dock-bar--xp {\n  border-left: 2px solid rgba(168, 85, 247, 0.45);\n}\n\n.corner-dock-bar--hp.is-dead {\n  border-left-color: rgba(239, 68, 68, 0.7);\n}\n\n.corner-dock-bar-icon {\n  flex-shrink: 0;\n}\n\n.corner-dock-bar--hp .corner-dock-bar-icon {\n  color: #4ade80;\n}\n\n.corner-dock-bar--xp .corner-dock-bar-icon {\n  color: #c084fc;\n}\n\n.corner-dock-bar--hp.is-dead .corner-dock-bar-icon {\n  color: #f87171;\n}\n\n.corner-dock-bar-track {\n  flex: 1;\n  min-width: 0;\n  height: 4px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 2px;\n  overflow: hidden;\n  position: relative;\n}\n\n.corner-dock-bar-fill {\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  border-radius: 2px;\n  transition: width 400ms cubic-bezier(0.34, 1.56, 0.64, 1), background 300ms ease;\n}\n\n.corner-dock-bar-fill--hp {\n  background: #22c55e;\n}\n\n.corner-dock-bar--hp.is-dead .corner-dock-bar-fill--hp {\n  background: #ef4444;\n}\n\n.corner-dock-bar-fill--xp {\n  background: #a855f7;\n}\n\n.corner-dock-bar-value {\n  font-size: 9.5px;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: 0.02em;\n  flex-shrink: 0;\n  min-width: 44px;\n  text-align: right;\n}\n\n:root[data-ui-density=\"compact\"] .corner-dock-bar-value {\n  min-width: 36px;\n  font-size: 9px;\n  letter-spacing: 0.01em;\n}\n\n.corner-dock-bar-value--hp {\n  color: rgba(134, 239, 172, 0.95);\n}\n\n.corner-dock-bar--hp.is-dead .corner-dock-bar-value--hp {\n  color: rgba(252, 165, 165, 0.95);\n}\n\n/* Indigo Mantle (Methylene Blue) — overworld invincibility (bar fill only, no halo) */\n.corner-dock-bar--hp.is-invincible .corner-dock-bar-fill--hp {\n  background: linear-gradient(90deg, #3b82f6, #60a5fa, #93c5fd);\n  animation: indigo-mantle-shimmer 2.4s ease-in-out infinite;\n}\n\n.corner-dock-bar--hp.is-invincible .corner-dock-bar-icon {\n  color: #93c5fd;\n}\n\n.corner-dock-bar--hp.is-invincible .corner-dock-bar-value--hp {\n  color: rgba(191, 219, 254, 0.98);\n  font-size: 14px;\n  letter-spacing: 0;\n}\n\n:root[data-ui-density=\"compact\"] .corner-dock-bar--hp.is-invincible .corner-dock-bar-value--hp {\n  min-width: 36px;\n  font-size: 12px;\n}\n\n@keyframes indigo-mantle-shimmer {\n  0%, 100% { filter: brightness(1); }\n  50% { filter: brightness(1.25); }\n}\n\n.corner-dock-bar-value--xp {\n  color: rgba(192, 132, 252, 0.92);\n}\n\n.bls-action-popover {\n  position: absolute;\n  left: 0;\n  bottom: calc(100% + 8px);\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 8px;\n  background: rgba(10, 10, 14, 0.96);\n  backdrop-filter: blur(14px);\n  -webkit-backdrop-filter: blur(14px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.65);\n  z-index: 20;\n  animation: bls-popover-in 180ms cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.bls-action-popover--upload {\n  border-left: 2px solid rgba(129, 140, 248, 0.55);\n}\n\n.bls-action-popover--processing {\n  border-left: 2px solid rgba(129, 140, 248, 0.55);\n  max-height: min(360px, calc(100vh - 260px));\n  overflow-y: auto;\n}\n\n.bls-action-popover--hp {\n  border-left: 2px solid rgba(34, 197, 94, 0.55);\n}\n\n@keyframes bls-popover-in {\n  from { opacity: 0; transform: translateY(-6px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* Upload / HP chips — mirror map-quest-chip language so popovers feel native. */\n.map-upload-chip {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 8px;\n  width: 100%;\n  background: rgba(10, 10, 14, 0.6);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-left: 2px solid rgba(129, 140, 248, 0.7);\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);\n  cursor: pointer;\n  text-align: left;\n  transition: border-color 150ms ease, background 150ms ease;\n}\n\n.map-upload-chip:hover {\n  background: rgba(10, 10, 14, 0.75);\n  border-color: rgba(129, 140, 248, 0.3);\n  border-left-color: rgba(165, 180, 252, 0.95);\n}\n\n.map-upload-chip--disabled,\n.map-upload-chip:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n  background: rgba(10, 10, 14, 0.45);\n  border-color: rgba(255, 255, 255, 0.05);\n  border-left-color: rgba(255, 255, 255, 0.12);\n  box-shadow: none;\n}\n\n.map-upload-chip--disabled .map-upload-chip-icon,\n.map-upload-chip:disabled .map-upload-chip-icon {\n  color: rgba(255, 255, 255, 0.38);\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.map-upload-chip-icon {\n  width: 22px;\n  height: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  border-radius: 5px;\n  color: rgba(165, 180, 252, 0.95);\n  background: rgba(129, 140, 248, 0.15);\n}\n\n.map-upload-chip-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.map-upload-chip-name {\n  font-size: 10.5px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.88);\n  letter-spacing: 0.01em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.map-upload-chip-sub {\n  font-size: 9px;\n  font-weight: 600;\n  color: rgba(165, 180, 252, 0.7);\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.map-upload-chip-body--processing {\n  gap: 0;\n}\n\n.map-upload-chip--processing-upload {\n  border-left-color: rgba(245, 158, 11, 0.72);\n}\n\n.map-upload-chip--processing-upload:hover {\n  border-color: rgba(245, 158, 11, 0.24);\n  border-left-color: rgba(252, 211, 77, 0.96);\n}\n\n.map-upload-chip--processing-concept {\n  border-left-color: rgba(59, 130, 246, 0.72);\n}\n\n.map-upload-chip--processing-concept:hover {\n  border-color: rgba(59, 130, 246, 0.24);\n  border-left-color: rgba(96, 165, 250, 0.96);\n}\n\n.bls-processing-icon--upload {\n  color: rgba(254, 240, 138, 0.95);\n  background: rgba(245, 158, 11, 0.16);\n}\n\n.bls-processing-icon--concept {\n  color: rgba(191, 219, 254, 0.95);\n  background: rgba(59, 130, 246, 0.16);\n}\n\n.bls-processing-spinner {\n  display: block;\n  animation: bls-processing-spin 0.9s linear infinite;\n}\n\n.bls-processing-value {\n  flex-shrink: 0;\n  font-size: 9.5px;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: 0.02em;\n}\n\n.bls-processing-value--upload {\n  color: rgba(254, 240, 138, 0.95);\n}\n\n.bls-processing-value--concept {\n  color: rgba(191, 219, 254, 0.95);\n}\n\n@keyframes bls-processing-spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n/* HP chips */\n.map-hp-chip {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 8px;\n  background: rgba(10, 10, 14, 0.6);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-left: 2px solid rgba(34, 197, 94, 0.7);\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);\n}\n\n.map-hp-chip--warn {\n  border-left-color: rgba(251, 191, 36, 0.8);\n}\n\n.map-hp-chip--danger {\n  border-left-color: rgba(239, 68, 68, 0.85);\n}\n\n.map-hp-chip-icon {\n  width: 22px;\n  height: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  border-radius: 5px;\n  color: rgba(134, 239, 172, 0.95);\n  background: rgba(34, 197, 94, 0.15);\n}\n\n.map-hp-chip-icon--warn {\n  color: rgba(253, 224, 71, 0.95);\n  background: rgba(251, 191, 36, 0.15);\n}\n\n.map-hp-chip-icon--danger {\n  color: rgba(252, 165, 165, 0.95);\n  background: rgba(239, 68, 68, 0.18);\n}\n\n.map-hp-chip-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.map-hp-chip-name {\n  font-size: 10.5px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.88);\n  letter-spacing: 0.01em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.map-hp-chip-sub {\n  font-size: 9px;\n  font-weight: 600;\n  color: rgba(134, 239, 172, 0.7);\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.map-hp-chip--warn .map-hp-chip-sub {\n  color: rgba(253, 224, 71, 0.75);\n}\n\n.map-hp-chip--danger .map-hp-chip-sub {\n  color: rgba(252, 165, 165, 0.85);\n}\n\n.map-hp-chip-bar {\n  height: 2px;\n  background: rgba(255, 255, 255, 0.08);\n  border-radius: 1px;\n  overflow: hidden;\n}\n\n.map-hp-chip-bar-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #22c55e, #4ade80);\n  border-radius: 1px;\n  transition: width 400ms ease;\n}\n\n.map-hp-chip-value {\n  font-size: 9.5px;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  color: rgba(134, 239, 172, 0.95);\n  letter-spacing: 0.02em;\n  flex-shrink: 0;\n}\n\n.bls-status-header--hp {\n  border-left: 2px solid rgba(34, 197, 94, 0.55);\n  cursor: pointer;\n  gap: 8px;\n}\n\n.bls-status-header--hp .bls-status-header-icon {\n  color: rgba(134, 239, 172, 0.95);\n}\n\n.bls-status-header--hp.is-dead {\n  border-left-color: rgba(239, 68, 68, 0.7);\n}\n\n.bls-status-header--hp.is-dead .bls-status-header-icon {\n  color: rgba(252, 165, 165, 0.95);\n}\n\n.bls-hp-bar {\n  flex: 1;\n  min-width: 0;\n  height: 4px;\n  background: rgba(255, 255, 255, 0.08);\n  border-radius: 2px;\n  overflow: hidden;\n}\n\n.bls-hp-bar-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #22c55e, #4ade80);\n  border-radius: 2px;\n  transition: width 400ms ease, background 300ms ease;\n}\n\n.bls-status-header--hp.is-dead .bls-hp-bar-fill {\n  background: linear-gradient(90deg, #ef4444, #fca5a5);\n}\n\n.bls-hp-value {\n  font-size: 9.5px;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  color: rgba(134, 239, 172, 0.95);\n  letter-spacing: 0.02em;\n  flex-shrink: 0;\n}\n\n.bls-status-header--hp.is-dead .bls-hp-value {\n  color: rgba(252, 165, 165, 0.95);\n}\n\n.bls-status-header--wand {\n  border-left: 2px solid rgba(148, 163, 184, 0.35);\n}\n\n.bls-status-header--wand .bls-status-header-icon {\n  color: rgba(148, 163, 184, 0.8);\n}\n\n.bls-status-header--wand.is-active {\n  border-left-color: var(--accent-primary, #ef4444);\n  background: rgba(239, 68, 68, 0.14);\n}\n\n.bls-status-header--wand.is-active .bls-status-header-icon,\n.bls-status-header--wand.is-active .bls-status-label {\n  color: #fca5a5;\n}\n\n.bls-status-header--wand.has-glow {\n  box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.38), 0 0 14px rgba(239, 68, 68, 0.35);\n  animation: wand-pulse 2.4s ease-in-out infinite;\n}\n\n.bls-status-header--wand.has-glow .bls-status-header-icon,\n.bls-status-header--wand.has-glow .bls-status-label {\n  color: #fca5a5;\n}\n\n@keyframes wand-pulse {\n  0%, 100% { box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.3), 0 0 10px rgba(239, 68, 68, 0.25); }\n  50%      { box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.55), 0 0 20px rgba(239, 68, 68, 0.5); }\n}\n\n.bls-status-header.is-disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.bls-status-header.is-disabled:hover {\n  background: rgba(10, 10, 14, 0.68);\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.bls-status-muted-tag {\n  margin-left: auto;\n  padding: 1px 6px;\n  border-radius: 6px;\n  background: rgba(148, 163, 184, 0.15);\n  color: rgba(148, 163, 184, 0.9);\n  font-size: 8.5px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n}\n\n.bls-status-header--upload {\n  border-left: 2px solid rgba(129, 140, 248, 0.55);\n}\n\n.bls-status-header--upload .bls-status-header-icon {\n  color: rgba(165, 180, 252, 0.95);\n}\n\n.bls-status-header--upload:hover {\n  border-left-color: rgba(165, 180, 252, 0.85);\n}\n\n.bls-status-header {\n  appearance: none;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  padding: 7px 10px;\n  background: rgba(10, 10, 14, 0.68);\n  backdrop-filter: blur(14px);\n  -webkit-backdrop-filter: blur(14px);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 10px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.45);\n  cursor: pointer;\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.78);\n  transition: background 150ms ease, color 150ms ease, border-color 150ms ease;\n  text-align: left;\n  justify-content: flex-start;\n}\n\n.bls-status-header:hover {\n  background: rgba(10, 10, 14, 0.78);\n  color: #fff;\n}\n\n.bls-status-header--icon-only {\n  max-width: 32px;\n  height: 32px;\n  padding: 0;\n  justify-content: center;\n  border-radius: 8px;\n}\n\n.bls-status-header--icon-only .bls-status-header-icon {\n  width: 14px;\n  height: 14px;\n}\n\n.bls-status-header--dock-hp {\n  min-height: 26px;\n  padding-top: 6px;\n  padding-bottom: 6px;\n}\n\n.bls-status-header--tab {\n  min-height: 32px;\n  padding: 7px 8px;\n  gap: 6px;\n}\n\n.bls-status-header--quests {\n  border-left: 2px solid rgba(239, 68, 68, 0.55);\n}\n\n.bls-status-header--ach {\n  border-left: 2px solid rgba(251, 191, 36, 0.55);\n}\n\n.bls-status-header--profile {\n  border-left: 2px solid rgba(6, 182, 212, 0.55);\n}\n\n.bls-status-header--quests .bls-status-header-icon {\n  color: rgba(252, 165, 165, 0.95);\n}\n\n.bls-status-header--ach .bls-status-header-icon {\n  color: rgba(251, 191, 36, 0.95);\n}\n\n.bls-status-header--profile .bls-status-header-icon {\n  color: rgba(103, 232, 249, 0.95);\n}\n\n.bls-status-profile-inline {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  flex: 1;\n  min-width: 0;\n  justify-content: flex-end;\n  margin-left: 2px;\n}\n\n.profile-inline-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 7px;\n  border-radius: 6px;\n  font-size: 11.5px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  font-variant-numeric: tabular-nums;\n  line-height: 1.2;\n}\n\n.profile-inline-chip--lv {\n  background: rgba(6, 182, 212, 0.16);\n  color: #67e8f9;\n  border: 1px solid rgba(6, 182, 212, 0.28);\n}\n\n.profile-inline-chip--elixir {\n  background: rgba(36, 254, 159, 0.12);\n  color: #24fe9f;\n  border: 1px solid rgba(36, 254, 159, 0.25);\n}\n\n.profile-inline-chip--elixir .elixir-amount {\n  font-size: inherit;\n}\n\n.bls-status-label {\n  flex: 1;\n  min-width: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.bls-status-count {\n  min-width: 16px;\n  padding: 0 6px;\n  height: 15px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  line-height: 1;\n  border-radius: 8px;\n  font-variant-numeric: tabular-nums;\n}\n\n.bls-status-header--quests .bls-status-count {\n  color: #fecaca;\n  background: rgba(239, 68, 68, 0.18);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n}\n\n.bls-status-header--ach .bls-status-count {\n  color: #fde68a;\n  background: rgba(251, 191, 36, 0.18);\n  border: 1px solid rgba(251, 191, 36, 0.3);\n}\n\n.bls-status-chevron {\n  color: rgba(255, 255, 255, 0.4);\n  transition: transform 150ms ease;\n  flex-shrink: 0;\n  transform: rotate(180deg);\n}\n\n.bls-status-chevron.collapsed {\n  transform: rotate(0deg);\n}\n\n.bls-status-overlay {\n  position: absolute;\n  bottom: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  z-index: 100;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-height: calc(100vh - 240px);\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.12) transparent;\n}\n\n:root[data-ui-density=\"compact\"] .bls-status-overlay {\n  max-height: calc(100vh - 204px);\n}\n\n.bls-status-overlay::-webkit-scrollbar {\n  width: 4px;\n}\n\n.bls-status-overlay::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.12);\n  border-radius: 2px;\n}\n\n.bls-status-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 6px;\n  background: rgba(10, 10, 14, 0.72);\n  backdrop-filter: blur(14px);\n  -webkit-backdrop-filter: blur(14px);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 10px;\n  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.55);\n}\n\n.bls-status-panel--quests {\n  border-left: 2px solid rgba(239, 68, 68, 0.55);\n}\n\n.bls-status-panel--ach {\n  border-left: 2px solid rgba(251, 191, 36, 0.55);\n}\n\n.bls-status-panel--profile {\n  border-left: 2px solid rgba(6, 182, 212, 0.55);\n  padding: 10px 10px 8px;\n  gap: 6px;\n}\n\n.profile-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 5px 4px;\n  border-radius: 6px;\n  transition: background 150ms ease;\n}\n\n.profile-row--cards {\n  cursor: pointer;\n}\n\n.profile-row--cards:hover {\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.profile-row-icon {\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n}\n\n.profile-row-icon--honor {\n  color: #fde68a;\n  background: rgba(251, 191, 36, 0.14);\n}\n\n.profile-row-icon--elixir {\n  color: #24fe9f;\n  background: rgba(36, 254, 159, 0.12);\n}\n\n.profile-row-icon--cards {\n  color: #93c5fd;\n  background: rgba(59, 130, 246, 0.14);\n}\n\n.profile-row-label {\n  flex: 1;\n  min-width: 0;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  color: rgba(255, 255, 255, 0.74);\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.profile-row-value {\n  font-size: 15px;\n  font-weight: 700;\n  color: rgba(255, 255, 255, 0.92);\n  font-variant-numeric: tabular-nums;\n  letter-spacing: 0.02em;\n}\n\n.profile-row--elixir .profile-row-value {\n  color: #24fe9f;\n}\n\n.profile-row--level {\n  padding: 7px 4px;\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 8px;\n  align-items: center;\n}\n\n.profile-row-level-badge {\n  padding: 2px 8px;\n  border-radius: 6px;\n  background: rgba(6, 182, 212, 0.15);\n  color: #67e8f9;\n  border: 1px solid rgba(6, 182, 212, 0.3);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  font-variant-numeric: tabular-nums;\n}\n\n.profile-row-bar {\n  height: 4px;\n  background: rgba(255, 255, 255, 0.08);\n  border-radius: 2px;\n  overflow: hidden;\n}\n\n.profile-row-bar-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #06b6d4, #67e8f9);\n  border-radius: 2px;\n  transition: width 400ms ease;\n}\n\n.profile-row--level .profile-row-value {\n  font-size: 10px;\n  color: rgba(255, 255, 255, 0.58);\n  letter-spacing: 0.04em;\n}\n\n.profile-row--pop .profile-row-value {\n  animation: profile-pop 320ms ease;\n}\n\n@keyframes profile-pop {\n  0% { transform: scale(1); }\n  40% { transform: scale(1.14); }\n  100% { transform: scale(1); }\n}\n\n.profile-breakdown {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 4px 6px 2px;\n  gap: 10px;\n}\n\n.profile-card-stat {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 10.5px;\n  font-weight: 700;\n  color: rgba(255, 255, 255, 0.78);\n  font-variant-numeric: tabular-nums;\n  letter-spacing: 0.02em;\n}\n\n.profile-card-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  display: inline-block;\n  flex-shrink: 0;\n}\n\n.profile-card-count {\n  min-width: 1.4ch;\n  text-align: left;\n}\n\n.profile-donut {\n  display: block;\n}\n\n.bls-status-panel .map-quest-chip,\n.bls-status-panel .map-ach-chip {\n  background: rgba(255, 255, 255, 0.02);\n  box-shadow: none;\n}\n\n.bls-status-panel .map-quest-chip:hover,\n.bls-status-panel .map-ach-chip:hover {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.map-quest-chip {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 8px;\n  background: rgba(10, 10, 14, 0.6);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-left: 2px solid rgba(239, 68, 68, 0.7);\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);\n  transition: border-color 150ms ease, background 150ms ease;\n}\n\n.map-quest-chip:hover {\n  background: rgba(10, 10, 14, 0.75);\n  border-color: rgba(239, 68, 68, 0.3);\n  border-left-color: rgba(252, 165, 165, 0.9);\n}\n\n.map-quest-chip--done {\n  border-left-color: rgba(74, 222, 128, 0.9);\n  opacity: 0.82;\n}\n\n.map-quest-chip-icon {\n  width: 22px;\n  height: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  border-radius: 5px;\n  color: rgba(252, 165, 165, 0.9);\n  background: rgba(239, 68, 68, 0.1);\n}\n\n.map-quest-chip-icon.review {\n  color: #818cf8;\n  background: rgba(99, 102, 241, 0.15);\n}\n\n.map-quest-chip-icon.train,\n.map-quest-chip-icon.drug_drill,\n.map-quest-chip-icon.tend_drugs {\n  color: #fbbf24;\n  background: rgba(245, 158, 11, 0.15);\n}\n\n.map-quest-chip-icon.learn,\n.map-quest-chip-icon.learn_level,\n.map-quest-chip-icon.annex_drugs {\n  color: #4ade80;\n  background: rgba(34, 197, 94, 0.15);\n}\n\n.map-quest-chip-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.map-quest-chip-name {\n  font-size: 10.5px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.88);\n  letter-spacing: 0.01em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.map-quest-chip-bar {\n  height: 2px;\n  background: rgba(255, 255, 255, 0.08);\n  border-radius: 1px;\n  overflow: hidden;\n}\n\n.map-quest-chip-bar-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #ef4444, #fca5a5);\n  border-radius: 1px;\n  transition: width 300ms ease;\n}\n\n.map-quest-chip--done .map-quest-chip-bar-fill {\n  background: linear-gradient(90deg, #22c55e, #4ade80);\n}\n\n.map-quest-chip-bounty {\n  font-size: 9.5px;\n  font-weight: 700;\n  color: rgba(74, 222, 128, 0.85);\n  letter-spacing: 0.04em;\n  font-variant-numeric: tabular-nums;\n  flex-shrink: 0;\n}\n\n.map-quest-chip-check {\n  color: #4ade80;\n  font-size: 13px;\n  line-height: 1;\n}\n\n.map-ach-chip {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 8px;\n  background: rgba(10, 10, 14, 0.6);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-left: 2px solid rgba(251, 191, 36, 0.7);\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);\n  transition: border-color 150ms ease, background 150ms ease;\n}\n\n.map-ach-chip:hover {\n  background: rgba(10, 10, 14, 0.75);\n  border-color: rgba(251, 191, 36, 0.3);\n  border-left-color: rgba(253, 224, 71, 0.9);\n}\n\n.map-ach-chip-icon {\n  width: 22px;\n  height: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fbbf24;\n  flex-shrink: 0;\n}\n\n.map-ach-chip-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.map-ach-chip-name {\n  font-size: 10.5px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.88);\n  letter-spacing: 0.01em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.map-ach-chip-bar {\n  height: 2px;\n  background: rgba(255, 255, 255, 0.08);\n  border-radius: 1px;\n  overflow: hidden;\n}\n\n.map-ach-chip-bar-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #f59e0b, #fbbf24);\n  border-radius: 1px;\n  transition: width 300ms ease;\n}\n\n.map-ach-chip-progress {\n  font-size: 9.5px;\n  font-weight: 600;\n  color: rgba(253, 224, 71, 0.75);\n  letter-spacing: 0.04em;\n  font-variant-numeric: tabular-nums;\n  flex-shrink: 0;\n}\n\n\n/* ─── Wand Popover ─────────────────────────────────────────────\n   Reuses .bls-action-popover + .map-upload-chip styles so it matches\n   the Upload / HP / Quest popovers exactly. Differs only in:\n     1. Position: pops out to the RIGHT of the BLS dock (not above),\n        so it doesn't cover the HP bars.\n     2. Left-border accent + icon tint: warm amber for wand identity.\n*/\n\n/* Wand popover pops out to the RIGHT of the entire BLS dock.\n   Anchored to .corner-dock-shell (same positioning ancestor as\n   .bls-action-popover--upload) so its edges align with the dock\n   exactly — top + bottom flush with the shell, left flush with the\n   shell's right edge + 8px gutter. Internal padding + chip sizes\n   are tightened so 3 chips fit inside the dock's height cleanly. */\n.bls-action-popover--wand {\n  left: calc(100% + 8px);\n  right: auto;\n  top: 0;\n  bottom: 0;\n  width: 200px;\n  padding: 5px;\n  gap: 3px;\n  border-left: 2px solid rgba(239, 68, 68, 0.6);\n  animation: bls-popover-right-in 180ms cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.bls-action-popover--wand .map-upload-chip {\n  flex: 1 1 0;\n  min-height: 0;\n  padding: 4px 8px;\n}\n\n.bls-action-popover--wand .map-upload-chip-icon {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n@keyframes bls-popover-right-in {\n  from { opacity: 0; transform: translateX(-6px); }\n  to   { opacity: 1; transform: translateX(0); }\n}\n\n/* Wand chip — neutral shell; per-action subaccents provide the color.\n   The popover box itself carries the red main accent. */\n.map-upload-chip--wand {\n  border-left-color: rgba(239, 68, 68, 0.35);\n}\n\n.map-upload-chip--wand:hover {\n  border-color: rgba(239, 68, 68, 0.2);\n}\n\n/* Forge — orange */\n.map-upload-chip--forge {\n  border-left-color: rgba(245, 158, 11, 0.75);\n}\n.map-upload-chip--forge:hover {\n  border-color: rgba(245, 158, 11, 0.3);\n  border-left-color: rgba(251, 191, 36, 0.95);\n}\n.map-upload-chip--forge .map-upload-chip-icon {\n  color: rgba(251, 191, 36, 0.95);\n  background: rgba(245, 158, 11, 0.15);\n}\n.map-upload-chip--forge .map-upload-chip-sub {\n  color: rgba(251, 191, 36, 0.7);\n}\n\n/* Vault — purple */\n.map-upload-chip--vault {\n  border-left-color: rgba(167, 139, 250, 0.75);\n}\n.map-upload-chip--vault:hover {\n  border-color: rgba(167, 139, 250, 0.3);\n  border-left-color: rgba(196, 181, 253, 0.95);\n}\n.map-upload-chip--vault .map-upload-chip-icon {\n  color: rgba(196, 181, 253, 0.95);\n  background: rgba(167, 139, 250, 0.15);\n}\n.map-upload-chip--vault .map-upload-chip-sub {\n  color: rgba(196, 181, 253, 0.7);\n}\n\n/* Cheat Sheet — cyan */\n.map-upload-chip--cheatsheet {\n  border-left-color: rgba(34, 211, 238, 0.75);\n}\n.map-upload-chip--cheatsheet:hover {\n  border-color: rgba(34, 211, 238, 0.3);\n  border-left-color: rgba(103, 232, 249, 0.95);\n}\n.map-upload-chip--cheatsheet .map-upload-chip-icon {\n  color: rgba(103, 232, 249, 0.95);\n  background: rgba(34, 211, 238, 0.15);\n}\n.map-upload-chip--cheatsheet .map-upload-chip-sub {\n  color: rgba(103, 232, 249, 0.7);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
